/* MEDIBUD — custom slide-out cart drawer.
   Status bar · lock-to-unlock milestones · complete-the-system → size-upgrade offers · protection · payments. */
(function(){
  var FREE=14900;    /* free standard shipping over $149 */
  var EXPRESS=24900; /* free express shipping over $249 */
  var PROT=54155395727644;   /* Shipping Protection · $3 */
  var ROAD={'46702398898460':1,'48495857729820':1,'54153281601820':1};
  var H_BUD='medibud-liquid-fertiliser',H_GROW='medigrow',H_BUNDLE='medibud-medigrow-bundle';
  var IDS={};
  IDS[H_BUD]={'1':46702398800156,'5':46702398865692,'20':46702398898460};
  IDS[H_GROW]={'1':48495857631516,'5':48495857697052,'20':48495857729820};
  IDS[H_BUNDLE]={'1':54153281536284,'5':54153281470748,'20':54153281601820};
  var NAME={};NAME[H_BUD]='Medibud\u00ae';NAME[H_GROW]='Medigrow\u00ae';
  var PHASE={};PHASE[H_BUD]='2';PHASE[H_GROW]='1';
  var ROLE={};ROLE[H_BUD]='Flowers, fruit &amp; yield';ROLE[H_GROW]='Roots, leaves &amp; lawns';
  var BFEED={'1':'88 feeds','5':'444 feeds','20':'1,777 feeds'};
  var BCPF={'1':63,'5':38,'20':31};
  var NEXT={'1':'5','5':'20'};
  var P1='<span class="mbd-phtag p1">Phase 1</span>',P2='<span class="mbd-phtag p2">Phase 2</span>';
  var cache={},wrap=null,busy=false,last=null,protBusy=false,lastSig='';

  function money(c){var v=c/100;return '$'+(v%1?v.toFixed(2):v.toLocaleString('en-AU'));}
  function sizeOf(t){var m=(t||'').replace(/,/g,'').match(/(\d+)\s*L/i);return m?m[1]:null;}
  function isOpen(){return wrap&&wrap.classList.contains('is-open');}
  function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
  function title(s){return esc(s).replace(/([A-Za-z])-([A-Za-z])/g,'$1\u2011$2');}
  function thumb(u){return u?u.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2'):'';}
  function protOff(){try{return sessionStorage.getItem('mbdProtOff')==='1';}catch(e){return false;}}
  function setProtOff(v){try{sessionStorage.setItem('mbdProtOff',v?'1':'0');}catch(e){}}
  function phaseTags(handle){
    if(handle===H_GROW)return P1;
    if(handle===H_BUD)return P2;
    if(handle===H_BUNDLE)return P1+P2;
    return '';
  }
  /* protection alone is not a cart */
  function realCount(cart){
    var n=0;
    ((cart&&cart.items)||[]).forEach(function(i){if(i.variant_id!==PROT)n+=i.quantity;});
    return n;
  }
  function protLine(cart){
    var line=0;
    ((cart&&cart.items)||[]).forEach(function(it,i){if(it.variant_id===PROT)line=i+1;});
    return line;
  }
  function sig(cart){
    if(!cart||!cart.items)return 'empty';
    return cart.item_count+'|'+cart.total_price+'|'+cart.items.map(function(i){
      return i.variant_id+':'+i.quantity;
    }).join(',');
  }
  function savedTotal(){
    if(!last||!last.items)return 0;
    var saved=0;
    last.items.forEach(function(it){
      var p=cache[it.handle];if(!p)return;
      p.variants.forEach(function(v){
        if(v.id===it.variant_id&&v.compare_at_price>v.price)saved+=(v.compare_at_price-v.price)*it.quantity;
      });
    });
    return saved+(last.total_discount||0);
  }
  function coWas(){
    if(!wrap||!last)return;
    var el=wrap.querySelector('.mbd-co-was');if(!el)return;
    var saved=savedTotal();
    if(saved>0){el.textContent=money(last.total_price+saved);el.hidden=false;}
    else el.hidden=true;
  }

  var LOCK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  var TICK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';
  var EMPTY='<div class="mbd-empty">'+
    '<span class="mbd-empty-mark"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21v-8"/><path d="M12 13c0-3.3 2.7-6 6-6 0 3.3-2.7 6-6 6z"/><path d="M12 15c0-3.3-2.7-6-6-6 0 3.3 2.7 6 6 6z"/></svg></span>'+
    '<h3>Your cart is empty</h3>'+
    '<p>Two feeds. A whole garden that thrives.</p>'+
    '<a class="mbd-eb primary" href="/products/medibud-medigrow-bundle">Shop the bundle</a>'+
    '<a class="mbd-eb" href="/products/medigrow">Shop Medigrow<i>Phase 1 \u00b7 roots, leaves &amp; lawns</i></a>'+
    '<a class="mbd-eb" href="/products/medibud-liquid-fertiliser">Shop Medibud<i>Phase 2 \u00b7 flowers, fruit &amp; yield</i></a>'+
  '</div>';

  function build(){
    if(wrap)return wrap;
    wrap=document.createElement('div');
    wrap.className='mbd-wrap';wrap.id='mbd-wrap';wrap.hidden=true;
    wrap.innerHTML='<div class="mbd-ov"></div>'+
      '<aside class="mbd" role="dialog" aria-modal="true" aria-label="Your cart">'+
        '<div class="mbd-top"><span class="mbd-status"><b>CART</b></span>'+
          '<button class="mbd-x" type="button" aria-label="Close cart" data-mbd-close>'+
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'+
        '</div>'+
        '<div class="mbd-progslot"></div>'+
        '<div class="mbd-body"></div>'+
        '<div class="mbd-footslot"></div>'+
      '</aside>';
    document.body.appendChild(wrap);
    if(!document.getElementById('mbd-ship-css')){var st=document.createElement('style');st.id='mbd-ship-css';
      st.textContent='.mbd-card-t .mbd-savechip{margin-right:6px}.mbd-shipchip{display:inline-block;margin-top:6px;margin-left:0;padding:3px 8px;border-radius:5px;background:#C6F03C;color:#0F3D24;font-family:"JetBrains Mono",monospace;font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;white-space:nowrap}.mbd-add small{display:block;font-size:10.5px;font-weight:600;line-height:1.1;margin-top:2px;color:#fff;opacity:.92;letter-spacing:0;text-transform:none}'+
        '.mbd-gtee{display:flex;align-items:center;gap:9px;padding:4px 0 12px;margin-top:0;font-family:"Hanken Grotesk",Helvetica,Arial,sans-serif;font-size:12px;line-height:1.35;color:#6E776C}.mbd-gtee svg{width:22px;height:22px;flex:none}.mbd-gtee b{color:#1A2620;font-weight:700}'+
        '.mbd-foot .mbd-pays{display:flex!important;justify-content:center;align-items:center;gap:6px;margin-top:10px;opacity:.6;filter:grayscale(1)}.mbd-foot .mbd-pays svg,.mbd-foot .mbd-pays .mbd-pay{height:18px!important;width:auto!important;max-width:36px}';
      document.head.appendChild(st);}
    wrap.querySelectorAll('[data-mbd-close]').forEach(function(b){b.addEventListener('click',close);});
    /* 8 Sep 2026 (owner): the drawer closes only via the X button — no overlay tap, no Escape. */
    window.addEventListener('resize',function(){if(isOpen())fitProt();});
    return wrap;
  }
  function open(){build();wrap.hidden=false;requestAnimationFrame(function(){wrap.classList.add('is-open');});document.documentElement.style.overflow='hidden';load();}
  function openAfterAdd(){open();[400,1200].forEach(function(ms){setTimeout(function(){if(isOpen())load();},ms);});}
  function close(){if(!wrap)return;wrap.classList.remove('is-open');document.documentElement.style.overflow='';setTimeout(function(){wrap.hidden=true;},340);}

  function fitProt(){
    if(!wrap)return;
    var el=wrap.querySelector('.mbd-prot small');
    if(!el||!el.clientWidth)return;
    var size=11.5,guard=0;
    el.style.whiteSpace='nowrap';
    el.style.fontSize=size+'px';
    while(el.scrollWidth>el.clientWidth&&size>8.6&&guard<40){
      size-=0.25;guard++;
      el.style.fontSize=size+'px';
    }
    if(el.scrollWidth>el.clientWidth){el.style.whiteSpace='normal';el.style.fontSize='11px';}
  }

  function prog(cart){
    var slot=wrap.querySelector('.mbd-progslot'),bar=wrap.querySelector('.mbd-status');
    if(!realCount(cart)){slot.innerHTML='';if(bar)bar.innerHTML='<b>CART</b>';return;}
    var sub=0,road=false;
    cart.items.forEach(function(i){
      if(i.variant_id!==PROT)sub+=i.final_line_price;
      if(ROAD[String(i.variant_id)])road=true;
    });
    var hit1=sub>=FREE,hit2=sub>=EXPRESS;
    if(bar){
      if(hit2)bar.innerHTML='<b>CART</b>: <b>FREE EXPRESS</b> unlocked \u2713';
      else if(hit1)bar.innerHTML='<b>CART</b>: You\u2019re <b>'+money(EXPRESS-sub)+' Away</b> from <b>FREE EXPRESS</b>';
      else bar.innerHTML='<b>CART</b>: You\u2019re <b>'+money(FREE-sub)+' Away</b> from <b>FREE SHIPPING</b>';
    }
    var p1=Math.round(FREE/EXPRESS*100);
    var pct=Math.min(100,Math.round(sub/EXPRESS*100));
    if(!slot.querySelector('.mbd-prog')){
      slot.innerHTML='<div class="mbd-prog">'+
        '<div class="mbd-rail"><div class="mbd-fill"></div>'+
          '<span class="mbd-mark m1" style="left:'+p1+'%"></span>'+
          '<span class="mbd-mark m2" style="left:100%"></span>'+
        '</div>'+
        '<div class="mbd-labs">'+
          '<span class="mbd-lab l1" style="left:'+p1+'%">Free shipping<i>Spend $149</i></span>'+
          '<span class="mbd-lab l2" style="left:100%;transform:translateX(-78%)">Free express<i>Spend $249</i></span>'+
        '</div>'+
        '<p class="mbd-note" hidden>20 L ships by road freight \u00b7 quoted at checkout</p>'+
      '</div>';
    }
    var m1=slot.querySelector('.mbd-mark.m1'),m2=slot.querySelector('.mbd-mark.m2');
    var l1=slot.querySelector('.mbd-lab.l1'),l2=slot.querySelector('.mbd-lab.l2');
    if(m1){m1.classList.toggle('hit',hit1);m1.innerHTML=hit1?TICK:LOCK;}
    if(m2){m2.classList.toggle('hit',hit2);m2.innerHTML=hit2?TICK:LOCK;}
    if(l1)l1.classList.toggle('hit',hit1);
    if(l2)l2.classList.toggle('hit',hit2);
    var note=slot.querySelector('.mbd-note');if(note)note.hidden=!road;
    var f=slot.querySelector('.mbd-fill');
    if(f)requestAnimationFrame(function(){f.style.width=pct+'%';});
  }

  function lines(cart){
    var body=wrap.querySelector('.mbd-body');
    if(!realCount(cart)){body.innerHTML=EMPTY;return;}
    var h='';
    cart.items.forEach(function(it,i){
      if(it.variant_id===PROT)return;
      var img=it.image?'<img class="mbd-thumb" src="'+thumb(it.image)+'" alt="" loading="lazy">':'<span class="mbd-thumb"></span>';
      var vt=(it.variant_title&&it.variant_title.indexOf('Default')<0)?'<p class="mbd-v">Size: '+esc(it.variant_title)+'</p>':'';
      var tags=phaseTags(it.handle);
      h+='<div class="mbd-item" data-idx="'+i+'">'+img+
        '<div class="mbd-info">'+
          (tags?'<span class="mbd-phs">'+tags+'</span>':'')+
          '<div class="mbd-hd"><p class="mbd-t">'+title(it.product_title)+'</p>'+
          '<span class="mbd-pr"><span class="mbd-was" hidden></span><span class="mbd-now">'+money(it.final_line_price)+'</span></span></div>'+
          vt+'<span class="mbd-save" hidden></span>'+
          '<div class="mbd-ctl"><div class="mbd-qty">'+
            '<button type="button" data-mbd-line="'+(i+1)+'" data-mbd-q="'+(it.quantity-1)+'"'+(it.quantity<2?' disabled':'')+' aria-label="Decrease">&minus;</button>'+
            '<span>'+it.quantity+'</span>'+
            '<button type="button" data-mbd-line="'+(i+1)+'" data-mbd-q="'+(it.quantity+1)+'" aria-label="Increase">+</button></div>'+
            '<button class="mbd-rm" type="button" data-mbd-line="'+(i+1)+'" data-mbd-q="0">Remove</button>'+
          '</div>'+
        '</div></div>';
    });
    body.innerHTML=h;
    body.querySelectorAll('[data-mbd-line]').forEach(function(b){
      b.addEventListener('click',function(){change(+b.getAttribute('data-mbd-line'),+b.getAttribute('data-mbd-q'));});
    });
    compare(cart,body);
    offers(cart,body);
  }

  function compare(cart,body){
    cart.items.forEach(function(it,i){
      prod(it.handle).then(function(p){
        coWas();
        if(!p)return;
        var v=null;p.variants.forEach(function(x){if(x.id===it.variant_id)v=x;});
        if(!v||!v.compare_at_price||v.compare_at_price<=v.price)return;
        var row=body.querySelector('.mbd-item[data-idx="'+i+'"]');if(!row)return;
        var was=row.querySelector('.mbd-was'),sv=row.querySelector('.mbd-save');
        if(was){was.textContent=money(v.compare_at_price*it.quantity);was.hidden=false;}
        if(sv){sv.textContent='You save '+Math.round((1-v.price/v.compare_at_price)*100)+'%';sv.hidden=false;}
      });
    });
  }

  function offers(cart,body){
    var have={},lineOf={},sz={};
    cart.items.forEach(function(it,i){
      if(it.variant_id===PROT)return;
      have[it.handle]=1;lineOf[it.handle]=i+1;
      sz[it.handle]=sizeOf(it.variant_title)||sizeOf(it.product_title);
    });
    if(have[H_BUNDLE])return sizeUp(sz[H_BUNDLE],lineOf[H_BUNDLE],body);
    var single=(have[H_BUD]&&!have[H_GROW])?H_BUD:((have[H_GROW]&&!have[H_BUD])?H_GROW:null);
    if(!single)return;
    completeSystem(single,sz[single]||'5',lineOf[single],body);
  }

  function shell(label){
    var box=document.createElement('div');
    box.className='mbd-up';
    box.innerHTML='<span class="mbd-up-lab">'+label+'</span>';
    return box;
  }

  function completeSystem(single,s,line,body){
    var other=single===H_BUD?H_GROW:H_BUD,vid=IDS[H_BUNDLE][s];
    var box=shell('Complete the system \u00b7 Phase 1 + Phase 2');
    var card=document.createElement('div');
    card.className='mbd-card';
    card.innerHTML='<span class="mbd-ph"></span>'+
      '<span class="mbd-card-t">'+
        '<span class="mbd-phtag p'+PHASE[other]+'">Phase '+PHASE[other]+'</span>'+
        '<b>Add '+NAME[other]+' '+s+' L</b>'+
        '<small>'+ROLE[other]+'</small>'+
        '<span class="mbd-savechip" hidden></span>'+
        '<span class="mbd-shipchip" hidden>+ Free shipping</span>'+
      '</span>'+
      '<button class="mbd-add" type="button">Add</button>';
    box.appendChild(card);body.appendChild(box);

    Promise.all([prod(H_BUNDLE),prod(other)]).then(function(r){
      var bundle=r[0],oth=r[1];
      if(!bundle)return;
      var bv=null;bundle.variants.forEach(function(x){if(x.id===vid)bv=x;});
      var item=null;(last&&last.items||[]).forEach(function(it,i){if(i+1===line)item=it;});
      var b=card.querySelector('.mbd-add');
      if(bv&&b){
        var diff=bv.price-(item?item.final_price:0);
        var label=diff>0?'Add \u00b7 +'+money(diff):'Add \u00b7 '+money(bv.price);
        /* FREE-SHIPPING LINK 8 Sep 2026 (owner review): if swapping the single for the bundle carries the
           cart over the $149 threshold, say so on the button and the card. 20 L bundles ship by road, so skip. */
        var sub=0;(last&&last.items||[]).forEach(function(x){if(x.variant_id!==PROT)sub+=x.final_line_price;});
        var after=sub-(item?item.final_line_price:0)+bv.price;
        var unlocks=sub<FREE&&after>=FREE&&!ROAD[String(vid)];
        if(unlocks){b.innerHTML=esc(label)+'<small>ships free</small>';var sc=card.querySelector('.mbd-shipchip');if(sc)sc.hidden=false;}
        else b.textContent=label;
      }
      if(bv&&bv.compare_at_price>bv.price){
        var chip=card.querySelector('.mbd-savechip');
        if(chip){chip.textContent='Save '+money(bv.compare_at_price-bv.price);chip.hidden=false;}
      }
      var src=null,ph=card.querySelector('.mbd-ph');
      if(oth){
        var ov=null,ovid=IDS[other][s];
        oth.variants.forEach(function(x){if(x.id===ovid)ov=x;});
        src=(ov&&ov.featured_image&&ov.featured_image.src)||oth.featured_image;
      }
      if(src&&ph){var im=document.createElement('img');im.loading='lazy';im.alt='';im.src=thumb((src.indexOf('//')===0?'https:':'')+src);ph.parentNode.replaceChild(im,ph);}
    });
    card.querySelector('.mbd-add').addEventListener('click',function(){
      var b=this;b.disabled=true;b.textContent='Adding\u2026';
      swap(line,vid).catch(function(){b.disabled=false;b.textContent='Try again';});
    });
  }

  function sizeUp(cur,line,body){
    if(!cur||!NEXT[cur]||!line)return;
    var up=NEXT[cur],vid=IDS[H_BUNDLE][up];
    var drop=Math.round((1-BCPF[up]/BCPF[cur])*100);
    var box=shell('Make it go further \u00b7 cost per feed');
    var card=document.createElement('div');
    card.className='mbd-card';
    card.innerHTML='<span class="mbd-ph"></span>'+
      '<span class="mbd-card-t">'+
        '<span class="mbd-phtag up">'+up+' L bundle</span>'+
        '<b>Upgrade to '+up+' L</b>'+
        '<small>'+BFEED[up]+' at '+BCPF[up]+'c a feed \u2014 down from '+BCPF[cur]+'c</small>'+
        '<span class="mbd-savechip">'+drop+'% less per feed</span>'+
      '</span>'+
      '<button class="mbd-add" type="button">Upgrade</button>';
    box.appendChild(card);body.appendChild(box);

    prod(H_BUNDLE).then(function(p){
      if(!p)return;
      var bv=null;p.variants.forEach(function(x){if(x.id===vid)bv=x;});
      var item=null;(last&&last.items||[]).forEach(function(it,i){if(i+1===line)item=it;});
      var b=card.querySelector('.mbd-add');
      if(bv&&b){
        var diff=bv.price-(item?item.final_price:0);
        b.textContent=diff>0?'Upgrade \u00b7 +'+money(diff):'Upgrade \u00b7 '+money(bv.price);
      }
      var src=(bv&&bv.featured_image&&bv.featured_image.src)||p.featured_image,ph=card.querySelector('.mbd-ph');
      if(src&&ph){var im=document.createElement('img');im.loading='lazy';im.alt='';im.src=thumb((src.indexOf('//')===0?'https:':'')+src);ph.parentNode.replaceChild(im,ph);}
    });
    card.querySelector('.mbd-add').addEventListener('click',function(){
      var b=this;b.disabled=true;b.textContent='Upgrading\u2026';
      swap(line,vid).catch(function(){b.disabled=false;b.textContent='Try again';});
    });
  }

  function foot(cart){
    var slot=wrap.querySelector('.mbd-footslot');
    if(!realCount(cart)){slot.innerHTML='';return;}
    var hasProt=false;
    cart.items.forEach(function(i){if(i.variant_id===PROT)hasProt=true;});
    var pays=document.getElementById('mbd-pays');
    slot.innerHTML='<div class="mbd-foot">'+
      '<label class="mbd-prot">'+
        '<span class="mbd-prot-row">'+
          '<span class="mbd-sw"><input type="checkbox"'+(hasProt?' checked':'')+'><i></i></span>'+
          '<b>Shipping Protection</b>'+
          '<span class="mbd-prot-p">$3</span>'+
        '</span>'+
        '<small>Provides coverage for packages that are lost, damaged or stolen during transit.</small>'+
      '</label>'+
      '<div class="mbd-gtee"><svg viewBox="8 6 32 32" aria-hidden="true"><polygon fill="#0F3D24" points="24.00,6.00 21.64,8.61 18.53,6.96 17.20,10.22 13.72,9.74 13.58,13.26 10.14,14.00 11.22,17.35 8.24,19.22 10.40,22.00 8.24,24.78 11.22,26.65 10.14,30.00 13.58,30.74 13.72,34.26 17.20,33.78 18.53,37.04 21.64,35.39 24.00,38.00 26.36,35.39 29.47,37.04 30.80,33.78 34.28,34.26 34.42,30.74 37.86,30.00 36.78,26.65 39.76,24.78 37.60,22.00 39.76,19.22 36.78,17.35 37.86,14.00 34.42,13.26 34.28,9.74 30.80,10.22 29.47,6.96 26.36,8.61"/><circle cx="24" cy="22" r="10.4" fill="#0F3D24"/><circle cx="24" cy="22" r="10.4" fill="none" stroke="#FAF9F8" stroke-width="1.1"/><path d="M19.4 22.3L22.6 25.5L29 18.6" fill="none" stroke="#C6F03C" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'+
        '<span><b>30-day money-back guarantee.</b> Not happy? Reply to your order email. No forms.</span></div>'+
      '<button class="mbd-co" type="button">Checkout<span class="mbd-co-s" aria-hidden="true">|</span>'+money(cart.total_price)+
        '<span class="mbd-co-was" hidden></span></button>'+
      '<div class="mbd-pays">'+(pays?pays.innerHTML:'')+'</div>'+
    '</div>';
    slot.querySelector('.mbd-co').addEventListener('click',function(){window.location.href='/checkout';});
    slot.querySelector('.mbd-prot input').addEventListener('change',function(){
      if(protBusy)return;protBusy=true;
      var on=this.checked;setProtOff(!on);
      setProt(on?1:0).then(function(){protBusy=false;}).catch(function(){protBusy=false;load();});
    });
    coWas();
    requestAnimationFrame(fitProt);
  }

  function autoProt(cart){
    if(protBusy)return;
    if(!realCount(cart))return;
    var q=0;
    cart.items.forEach(function(i){if(i.variant_id===PROT)q+=i.quantity;});
    if(q>1){protBusy=true;setProt(1).then(function(){protBusy=false;}).catch(function(){protBusy=false;});return;}
    if(protOff()||q===1)return;
    protBusy=true;
    setProt(1).then(function(){protBusy=false;}).catch(function(){protBusy=false;});
  }

  /* If every product is gone, drop the protection line too — nobody should
     be left with a cart containing nothing but a $3 fee. */
  function tidy(cart){
    if(protBusy)return false;
    if(realCount(cart))return false;
    var line=protLine(cart);
    if(!line)return false;
    protBusy=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:line,quantity:0})})
      .then(function(r){return r.json();})
      .then(function(c){protBusy=false;paint(c);document.dispatchEvent(new CustomEvent('cart:updated'));})
      .catch(function(){protBusy=false;});
    return true;
  }

  function paint(cart){
    last=cart;
    var s=sig(cart);
    var built=!!wrap.querySelector('.mbd-prog')||!!wrap.querySelector('.mbd-empty');
    if(s===lastSig&&built){autoProt(cart);return;}
    lastSig=s;
    prog(cart);lines(cart);foot(cart);
    if(!tidy(cart))autoProt(cart);
  }

  function prod(handle){
    if(cache[handle])return Promise.resolve(cache[handle]);
    return fetch('/products/'+handle+'.js').then(function(r){return r.ok?r.json():null;})
      .then(function(p){cache[handle]=p;return p;}).catch(function(){return null;});
  }
  function load(){
    build();
    return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();})
      .then(function(c){paint(c);return c;}).catch(function(){});
  }
  function add(id,qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:qty}]})})
      .then(function(r){if(!r.ok)throw new Error('add');return r.json();})
      .then(function(){document.dispatchEvent(new CustomEvent('cart:updated'));return load();});
  }
  /* PROTECTION 8 Sep 2026: set the protection line to an absolute quantity via update.js so racing
     calls (auto-add + toggle + refresh) can never stack it to 2 x $3. */
  function setProt(q){
    var u={};u[PROT]=q;
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:u})})
      .then(function(r){if(!r.ok)throw new Error('prot');return r.json();})
      .then(function(c){document.dispatchEvent(new CustomEvent('cart:updated'));paint(c);return c;});
  }
  function swap(line,vid){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:line,quantity:0})})
      .then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:vid,quantity:1}]})});})
      .then(function(r){if(!r.ok)throw new Error('swap');document.dispatchEvent(new CustomEvent('cart:updated'));return load();});
  }
  function change(line,qty){
    if(busy)return;busy=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(c){busy=false;paint(c);document.dispatchEvent(new CustomEvent('cart:updated'));})
      .catch(function(){busy=false;load();});
  }

  if(location.pathname.indexOf('/cart')!==0){
    document.addEventListener('click',function(e){
      if(!e.target||!e.target.closest)return;
      if(e.target.closest('button, [type="submit"], .cta, .sbtn2, .mbd-eb'))return;
      if(e.target.closest('.mbd')&&!e.target.closest('.mbd-eb'))return;
      if(!e.target.closest('a.mb-cart, a[href="/cart"], .mbc-cart'))return;
      e.preventDefault();open();
    });
  }
  ['ajaxProduct:added','cart-drawer:open'].forEach(function(ev){
    document.addEventListener(ev,function(){setTimeout(openAfterAdd,150);});
  });
  ['cart:updated','cart:refresh'].forEach(function(ev){
    document.addEventListener(ev,function(){if(isOpen())setTimeout(load,250);});
  });
})();
